import type { LoginResponse, MeResponse } from '@staiter/shared';
import { create } from 'zustand';
import { tokenStorage } from '~/lib/api/client';

type AuthState = {
  user: MeResponse | null;
  mustReset: boolean;
  isLoading: boolean;
  setFromLogin: (resp: LoginResponse) => void;
  setMe: (me: MeResponse) => void;
  clear: () => void;
};

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  mustReset: false,
  isLoading: false,

  setFromLogin: (resp) => {
    tokenStorage.set(resp.access_token, resp.refresh_token);
    set({
      mustReset: resp.must_reset,
      user: null, // полный /me подгрузится отдельно
    });
  },

  setMe: (me) => {
    set({ user: me, mustReset: me.must_reset });
  },

  clear: () => {
    tokenStorage.clear();
    set({ user: null, mustReset: false });
  },
}));
